// extracted by mini-css-extract-plugin
export default {"switchGroup":"switchGroup__mw0yR","switchLabel":"switchLabel__s79Wf","switchIndicator":"switchIndicator__aAGvj"};